import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PricingModel } from '@guryou/core';
import { Block, DateTimePicker, DeleteIcon, FlexRow, HiddenField, IconButton, NumberBox, PriceBox, Title } from '@guryou/html-components';
import { addMinutes } from '@guryou/utils';

const WeekDateItem = ({ day, gyClass, name, handleDeleteDay }) => {
  const { t } = useTranslation();
  const [ls, setLs] = useState({
    id: day?.id,
    price: day?.price,
    startDate: day?.startDate,
    startTime: day?.startTime,
    endTime: day?.endTime,
    duration: +day?.duration,
    dayOfWeek: day?.dayOfWeek,
    dayOfWeekText: day?.dayOfWeekText,
  });

  return (
    <FlexRow margin={0} padding={0} alignItems="center" justifyContent="space-between">
      <FlexRow xs={12} margin={0} padding={0} justifyContent="space-between">
        <Block xs={2} margin={0} padding={0}>
          <Title margin={0} padding={0} title={ls.dayOfWeekText} description={t('GENERAL.day')}></Title>
        </Block>
        <NumberBox
          xs={1.4}
          margin="0px 0px 8px 0px"
          required
          disabled
          inputProps={{ min: 5, step: 5 }}
          label={t('SERVICES.duration')}
          defaultValue={ls?.duration}
          name={`${name}[duration]`}
          onChange={val => {
            let price = ls.price;
            if (gyClass.model === PricingModel.hour) {
              price = (+val / 60) * gyClass.price;
            }
            setLs(s => ({ ...s, price, duration: +val, endTime: addMinutes(s.startTime, val) }));
          }}
        />
        {gyClass?.model !== PricingModel.total && (
          <PriceBox xs={1.6} margin="0px 0px 8px 0px" value={ls?.price} disabled={gyClass?.model !== PricingModel.custom} label={'Prezzo'} />
        )}
        <DateTimePicker
          xs={2}
          margin="0px 0px 8px 0px"
          label={t('GENERAL.from')}
          timeFieldName={`${name}[startTime]`}
          value={ls?.startTime}
          onChange={val => {
            setLs(s => ({ ...s, startTime: val, endTime: addMinutes(val, s.duration) }));
          }}
        />
        <DateTimePicker
          xs={2}
          margin="0px 0px 8px 0px"
          key={+ls?.endTime}
          label={t('GENERAL.to')}
          timeFieldName={`${name}[endTime]`}
          value={ls?.endTime}
          disableField={true}
        />
        <FlexRow xs={1} margin={0} padding={0} alignItems="end">
          <IconButton icon={DeleteIcon} color="secondary" onClick={() => handleDeleteDay(ls.id)} />
        </FlexRow>
      </FlexRow>
      <HiddenField value={ls.price} name={`${name}[price]`}></HiddenField>
      <HiddenField value={ls.id} name={`${name}[id]`}></HiddenField>
      <HiddenField value={ls.dayOfWeek} name={`${name}[dayOfWeek]`}></HiddenField>
      <HiddenField value={ls.duration} name={`${name}[duration]`}></HiddenField>
    </FlexRow>
  );
};
const areEqual = (prevProps, nextProps) => JSON.stringify(prevProps) === JSON.stringify(nextProps);
export default React.memo(WeekDateItem, areEqual);
